import gql from 'graphql-tag';

export const GETALLPLANTILLAS = gql`
    query{
        plantillas{
            _id
            nombre
            descripcion
            activo
        }
    }
`;


export const GETPLANTILLA = gql`
    query($id:String){
      plantilla(id:$id){
        _id
        nombre
        descripcion
        subcatActivas{
                id
                nombre
            }
            enunciado
            peso
            orden
        }
    }
`;

export const NEWPLANTILLA = gql`
    mutation($plantilla:String){
        newPlantilla(plantilla:$plantilla)
    }
`;

export const EDITPLANTILLA = gql`
    mutation($id:String, $plantilla:String){
        editPlantilla(id:$id, plantilla:$plantilla)
    }
`;
